export default "__VITE_ASSET__CJm_fa13__"